import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { setupListeners } from '@reduxjs/toolkit/query';
import { PostHogErrorBoundary, PostHogProvider } from 'posthog-js/react';
import { App } from './App';
import { CrashScreen } from './CrashScreen';
import { store } from './store';
import './styles.css';
import { posthog } from './lib/posthog';
import { listenForInstallPrompt } from './features/install/platform';
import { noteArrivalEmail } from './features/notifications/askPolicy';

// Before render: Chrome fires its one install prompt early in the page's life,
// and the arrival email's marker must come off the URL before routing reads it.
listenForInstallPrompt();
noteArrivalEmail();

// Lets RTK Query refetch when the app regains focus or the network returns
// (opted into per API with refetchOnFocus / refetchOnReconnect).
setupListeners(store.dispatch);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* The provider feeds the feature flag hooks in lib/flags; the boundary
        reports render crashes to Error tracking. */}
    <PostHogProvider client={posthog}>
      <PostHogErrorBoundary fallback={<CrashScreen />}>
        <Provider store={store}>
          <App />
        </Provider>
      </PostHogErrorBoundary>
    </PostHogProvider>
  </StrictMode>,
);

// Registered only in a build: in dev the SW would shadow Vite's HMR.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // A missing service worker degrades to a normal website, which is fine.
    });
  });
}
